/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Total = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  color: ${Palette.PrimaryGray._500};
  padding-left: 80px;
  background-color: ${Palette.PrimaryGray._100};
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
  user-select: none;
`;
